/* RUN 42 — lazy autoplay : les <video data-r42-lazy> et la vidéo .r42-solve__video
   sont posées avec preload="none" et SANS autoplay ; on lance play() (donc le
   téléchargement) seulement à l'approche de l'écran, et on met en pause hors écran.
   Mesuré 19/08/2026 : 9,2 MB de vidéo téléchargés d'office sur une fiche de 9,9 MB. */
(function () {
  var vids = document.querySelectorAll('video[data-r42-lazy], video.r42-solve__video');
  if (!vids.length) return;
  function start(v) {
    if (v.dataset.poster && !v.poster) v.poster = v.dataset.poster;
    if (v.preload === 'none') v.preload = 'auto';
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }
  if (!('IntersectionObserver' in window)) { vids.forEach(start); return; }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) start(e.target); else e.target.pause();
    });
  }, { rootMargin: '400px 0px' });
  vids.forEach(function (v) { io.observe(v); });
})();
